import { apiEndpoints } from 'settings/_apiSettings'
import axios from 'settings/axios'

export interface CreatePatientTreatmentPayload {
  medical_request_uuid: string;
  plan_code: string;
}

interface CreatePatientTreatmentParams {
  data: CreatePatientTreatmentPayload;
  username: string;
}

interface CreatePatientTreatmentResponse {
  id: string;
}

const createPatientTreatment = async ({
  username,
  data
}: CreatePatientTreatmentParams): Promise<CreatePatientTreatmentResponse> => {
  const endpoint = apiEndpoints.PATIENTS_TREATMENT(username)
  const result: CreatePatientTreatmentResponse = await axios.post(endpoint, data)
  return result
}

export {
  createPatientTreatment
}

